import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';
import { useTheme } from '../../../../theme';
const DocumentCard = ({ document, index, docTypeLabel, citizenshipLabel, onEdit, onRemove }) => {
    const { DocumentCard: css } = useTheme('TravellerForm');
    const { t: tTraveller } = useTranslation('Traveller');
    const details = [document.docNumber, document.docExpiryDate].filter(Boolean).join(', ');
    return (React.createElement("div", { className: css.documentCard },
        React.createElement("div", { className: css.documentCard__icon },
            React.createElement(CdnIcon, { icon: "Document/Passport" })),
        React.createElement("div", { className: css.documentCard__info },
            React.createElement("div", { className: css.documentCard__type }, docTypeLabel),
            citizenshipLabel && React.createElement("div", { className: css.documentCard__details }, citizenshipLabel),
            details && React.createElement("div", { className: css.documentCard__details }, details),
            React.createElement("div", { className: css.documentCard__edit, onClick: () => onEdit(index) }, tTraveller('Edit'))),
        onRemove && (React.createElement("div", { className: css.documentCard__remove, onClick: () => onRemove(index) },
            React.createElement(CdnIcon, { icon: "Action/Remove" })))));
};
export default DocumentCard;
